import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './componants/Navbar';
import React, { Suspense } from 'react';

import Hero from './componants/Hero';
const MeetCarleen = React.lazy(() => import('./componants/MeetCarleen'));
const CTA = React.lazy(() => import('./componants/CTA'));
const Reviews = React.lazy(() => import('./componants/Reviews'));
const MeetTheTeam = React.lazy(() => import('./componants/MeetTheTeam'));
const Appraisal = React.lazy(() => import('./componants/Appraisal'));
const SeniorDiscounts = React.lazy(() => import('./componants/SeniorDiscounts'));
// Lazy loading components
const Contact = React.lazy(() => import('./componants/Contact'));
const Listings = React.lazy(() => import('./componants/Listings'));
const Sold = React.lazy(() => import('./componants/Sold'));
const House = React.lazy(() => import('./componants/House'));
const Footer = React.lazy(() => import('./componants/Footer'));

// function App() {
//   return (
//     <div className="App">
//       <Router>
//         <Navbar />
//         <Suspense fallback={<div>Loading...</div>}>
//           <Routes>
//             <Route 
//               path="/" 
//               element={
//                 <>
//                   <Hero />
//                   <MeetCarleen />
//                   <CTA />
//                   <MeetTheTeam />
//                   <SeniorDiscounts />
//                   <Reviews />
//                 </>
//               } 
//             />
//             <Route path="/contact" element={<Contact />} /> 
//             <Route path="/appraisal" element={<Appraisal />} /> 
//             <Route path="/listings" element={<Listings />} /> 
//             <Route path="/sold" element={<Sold />} /> 
//             <Route path="/house/:id" element={<House />} /> 
//             {/* <Route path="/blog-small-business-website-nz" element={<BlogSmallBusinessWebsiteNZ />} /> 
//             <Route path="/blog-mahidesign" element={<BlogMahiDesign />} /> 
//             <Route path="/services" element={
//               <>
//                 <Services />
//                 <ServicesDream />
//                 <ServicesLikelihood />
//                 <ServicesEffortTime />
//               </>
//               } />  */}
//           </Routes>
//           <Footer />
//         </Suspense>
//       </Router>
//     </div>
//   );
// }
// export default App;

export default function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                {/* LCP should render immediately */}
                <Hero />

                {/* Below-the-fold sections can stream in later */}
                <Suspense fallback={null}><MeetCarleen /></Suspense>
                <Suspense fallback={null}><CTA /></Suspense>
                <Suspense fallback={null}><MeetTheTeam /></Suspense>
                <Suspense fallback={null}><SeniorDiscounts /></Suspense>
                <Suspense fallback={null}><Reviews /></Suspense>
              </>
            }
          />

          {/* Route pages can each get their own small boundary */}
          <Route path="/contact"  element={<Suspense fallback={null}><Contact /></Suspense>} />
          <Route path="/appraisal" element={<Suspense fallback={null}><Appraisal /></Suspense>} />
          <Route path="/listings" element={<Suspense fallback={null}><Listings /></Suspense>} />
          <Route path="/sold"     element={<Suspense fallback={null}><Sold /></Suspense>} />
          <Route path="/house/:id" element={<Suspense fallback={null}><House /></Suspense>} />
        </Routes>

        {/* Don’t block on footer either */}
        <Suspense fallback={null}><Footer /></Suspense>
      </Router>
    </div>
  );
}


